import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FoundCustomer } from '../../../../../customer/model/found-customer.model';
import { I18nInterpolateDirective } from '../../../../../i18n/components/i18n-interpolate.directive';
import { I18nComponent } from '../../../../../i18n/components/i18n.component';
import { useI18n } from '../../../../../i18n/services/i18n.service';
import { SearchResultMode } from '../../model/search-result-mode.model';
import { SearchResultComponent } from '../search-result/search-result.component';

@Component({
  selector: 'cdf-valid-search-results',
  imports: [SearchResultComponent, I18nComponent, I18nInterpolateDirective],
  template: `
    @for (result of searchResults(); track result) {
      <cdf-search-result
        [customer]="result"
        [loadingCustomer]="loadingCustomer()"
        [searchResultMode]="searchResultMode()"
        [readonly]="readonly()"
        (openCustomerProfile)="openCustomerProfile.emit(result)"
      />
    }

    @if (searchResultMode() === SearchResultMode.CUSTOMER_SEARCH && !readonly()) {
      <div class="link-container title-s text-neutral">
        <i18n key="searchResults.ifYouDontSeeCorrectCustomer">
          <a *i18nInterpolate="'cta'" class="hyperlink" (click)="createNewCustomer.emit()">{{
            i18n('searchResults.createNewCustomerLinkWhenFound')
          }}</a>
        </i18n>
      </div>
    }
  `,
  styleUrl: './valid-search-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidSearchResultsComponent {
  protected readonly i18n = useI18n();

  /**
   * Describes which customers profile is currently being opened and should display a loading state
   */
  readonly loadingCustomer = input<FoundCustomer | undefined>();
  readonly searchResultMode = input<SearchResultMode>(SearchResultMode.CUSTOMER_SEARCH);
  readonly searchResults = input<FoundCustomer[]>();
  readonly readonly = input(false);

  readonly openCustomerProfile = output<FoundCustomer>();
  readonly createNewCustomer = output();

  protected readonly SearchResultMode = SearchResultMode;
}
